/*
**************************************************************************
Title:          Chat component
Created By:     Pankaj Arora
Created on:     05/04/2018
Description:    This directive will scroll the message div to bottom
                so the users always see their latest messages first
**************************************************************************
*/
import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appBotScrollBottom]',
    standalone: false
})
export class ScrollBottomDirective {

  mutationObserver: MutationObserver;

  constructor(private elementRef: ElementRef) {
    this.mutationObserver = new MutationObserver(this.mutation);
    this.mutationObserver.observe(this.elementRef.nativeElement, {childList: true});
  }

  mutation = (mutations: [MutationRecord] , observer: MutationObserver) => {
    this.scrollToBottom();
  }

  scrollToBottom = () => {
    this.elementRef.nativeElement.scrollTop = this.elementRef.nativeElement.scrollHeight;
  }
}
